export function isSafeExternalUrl(value: unknown): value is string {
  if (typeof value !== 'string' || !value.trim()) return false;
  try {
    const url = new URL(value);
    return url.protocol === 'https:' || url.protocol === 'http:';
  } catch (_error) {
    return false;
  }
}

export function openCeDirectoryUrl(value: unknown, target: Window = window): boolean {
  if (!isSafeExternalUrl(value)) return false;
  const cordovaOpen = (target as any).cordova?.InAppBrowser?.open;
  if (typeof cordovaOpen === 'function') {
    cordovaOpen.call((target as any).cordova.InAppBrowser, value, '_system', 'location=yes');
    return true;
  }
  const opened = target.open(value, '_blank', 'noopener,noreferrer');
  if (opened) opened.opener = null;
  // With noopener, browsers return null even when the new tab opens. The
  // handle cannot tell us whether this safe navigation attempt succeeded.
  return true;
}
